module.exports =
{

  _accepted: false,

  _init: function ()
  {
    this.onAnswer()
    this.onConfirm()
    this.onAccept()
    this.onContinue()
  },

  onAnswer: function ()
  {

    window.onload = () => {
      if (document.querySelector('.js-vonage').checked) {
        document.querySelector('.js-confirm').removeAttribute('disabled')
      }
    }

    $('.js-vonage').not('.js-ignore').change(function ()
    {

      if (0 !== $('.js-vonage:checked').length)
      {
        $('.js-confirm').prop('disabled', false)
      }

      else
      {
        $('.js-confirm').prop('disabled', true)
      }

    }).addClass('js-ignore')

  },

  onConfirm: function ()
  {

    $('.js-confirm').not('.js-ignore').click(function ()
    {

      if (!APPLICATION.Vonage.view._accepted && '1' === $('.js-vonage:checked').val())
      {
        APPLICATION.Vonage.view.showTerms()
      }

      else
      {
        $('#vonage-form').submit()
      }

    }).addClass('js-ignore')

  },

  onAccept: function ()
  {

    $('#vonage-accept').not('.js-ignore').click(function ()
    {

      APPLICATION.Vonage.view._accepted = true

      $('#vonage-terms').modal('hide')
      $('#vonage-complete').modal('show')

      APPLICATION._APPLICATION.setCookie('vonage_modal_seen', 'TRUE', 7, false)

    }).addClass('js-ignore')

  },

  onContinue: function ()
  {

    $('#vonage-continue').not('.js-ignore').click(function ()
    {
      $('#vonage-form').submit()
    }).addClass('js-ignore')

  },

  showTerms: function ()
  {
    $('#vonage-terms').modal('show')
  }

}
